import { createToaster } from '@meforma/vue-toaster';

import { syncOverlayGuests } from '../helpers/open-dialogs';

import './toast.css';

/**
 * Позиция top (центр верха): дефолтный bottom-right ложится поверх футеров
 * правых side pane / корзины шахматки и перехватывает клики по их кнопкам.
 */
const toaster = createToaster({
  position: 'top',
  useDefaultCss: false,
});

// Библиотека синхронно возвращает контейнеры в body перед каждым тостом, а над окном нужны они там, где окно.
export const useToast = () => {
  const notify = (kind: 'show' | 'error' | 'success') => (msg: string) => {
    toaster[kind](msg);
    syncOverlayGuests();
  };

  return { show: notify('show'), error: notify('error'), success: notify('success') };
};
